var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.imp},[_c('div',{staticClass:"card-img"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"card-body"},[_c('h2',[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._v(_vm._s(_vm.txt))])])])}
var staticRenderFns = []

export { render, staticRenderFns }